var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useRef, useState } from 'react';
import { debounce } from 'lodash';
import classNames from 'classnames';
import { postJson } from '../common/utils';
import { useTranslation } from 'react-i18next';
export function AnswerComment({ gradingRole, answer, setExamAndScores, setLocalizedError, canBeCommented, postCommentUrl }) {
    var _a;
    const [saved, setSaved] = useState(false);
    const { t } = useTranslation();
    const localizedCommentSuffixKey = gradingRole === 'pregrading' ? 'arpa.comment_suffix_teacher' : 'arpa.comment_suffix_censor';
    const [newComment, setNewComment] = useState(false);
    const answerCommentRef = useRef(null);
    useEffect(() => {
        adjustInitialHeightOfCommentElement();
        setNewComment(false);
    }, [answer.answerId]);
    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
        function handleKeyDown(e) {
            const isCtrlI = e.key === 'i' && !e.altKey && e.ctrlKey && !e.metaKey && !e.shiftKey;
            if (isCtrlI) {
                if (answer.comment == undefined) {
                    setExamAndScores(previousState => updateCommentState(previousState, ''));
                    setNewComment(true);
                }
                else {
                    const scoreComment = answerCommentRef.current;
                    if (scoreComment) {
                        scoreComment.focus();
                        const contentLength = scoreComment.value.length;
                        scoreComment.setSelectionRange(contentLength, contentLength);
                        scoreComment.scrollIntoView();
                    }
                }
            }
        }
    }, [answer]);
    return (React.createElement("div", { className: "comment" }, answer.comment == undefined && !newComment ? (canBeCommented && (React.createElement("button", { className: "addCommentToAnswer button", onClick: () => {
            setExamAndScores(previousState => updateCommentState(previousState, ''));
            setNewComment(true);
        } }, t('arpa.comment_answer')))) : (React.createElement(React.Fragment, null,
        answer.isProductive && (React.createElement("em", { "data-testid": "pregrading-only-for-teachers" }, t('sa.pregrading.only_visible_to_teacher'))),
        React.createElement("label", { htmlFor: "note-textarea" },
            React.createElement("h4", null,
                t('arpa.comment'),
                "\u00A0",
                React.createElement("span", { className: "commentSuffix" }, t(localizedCommentSuffixKey)))),
        (canBeCommented || newComment) && (React.createElement("button", { className: "removeComment", onClick: () => {
                updateComment(undefined);
                setNewComment(false);
            } },
            React.createElement("i", { className: "fa fa-times-circle" }),
            React.createElement("span", null, t('arpa.remove_comment')))),
        (canBeCommented || ((_a = answer.comment) === null || _a === void 0 ? void 0 : _a.length) || newComment) && (React.createElement("textarea", { ref: answerCommentRef, spellCheck: false, key: answer.answerId, id: "note-textarea", className: "scoreComment", tabIndex: -1, defaultValue: answer.comment, autoFocus: true, disabled: !canBeCommented, onInput: e => {
                setSaved(false);
                adjustHeightOfCommentElement();
                answerCommentChange(e.currentTarget.value, (value) => {
                    updateComment(value);
                    setSaved(true);
                });
            } })),
        React.createElement("div", { className: classNames('savedIndicator', { 'savedIndicator--saved': saved, invisible: !saved }) }, t('arpa.saved'))))));
    function updateCommentState(previousState, comment) {
        if (!previousState)
            return previousState;
        return Object.assign(Object.assign({}, previousState), { students: previousState.students.map(student => {
                if (student === null || student === void 0 ? void 0 : student.answers.find(({ answerId }) => answerId === answer.answerId)) {
                    return Object.assign(Object.assign({}, student), { answers: student.answers.map(studentAnswer => {
                            if (studentAnswer.answerId === answer.answerId) {
                                return Object.assign(Object.assign({}, studentAnswer), { comment });
                            }
                            else
                                return studentAnswer;
                        }) });
                }
                else
                    return student;
            }) });
    }
    function updateComment(valueWithWhitespace) {
        const value = valueWithWhitespace === null || valueWithWhitespace === void 0 ? void 0 : valueWithWhitespace.trim();
        const postComment = () => __awaiter(this, void 0, void 0, function* () {
            const response = yield postJson(postCommentUrl, {
                comment: value !== null && value !== void 0 ? value : null
            });
            if (response.status >= 400) {
                setLocalizedError({ localizeKey: 'arpa.errors.saving_comment_failed' });
            }
            else {
                setExamAndScores(previousState => updateCommentState(previousState, value));
            }
        });
        postComment().catch(err => {
            setLocalizedError({ localizeKey: 'arpa.errors.saving_comment_failed' });
        });
    }
    function adjustInitialHeightOfCommentElement() {
        const commentElement = document.querySelector('.scoreComment');
        if (commentElement) {
            commentElement.style.height = `${commentElement.scrollHeight}px`;
        }
    }
    function adjustHeightOfCommentElement() {
        const commentElement = document.querySelector('.scoreComment');
        if (commentElement) {
            const { scrollX, scrollY } = window;
            commentElement.style.height = 'auto';
            commentElement.style.height = `${commentElement.scrollHeight}px`;
            window.scrollTo(Math.round(scrollX), Math.round(scrollY));
        }
    }
}
const answerCommentChange = debounce((value, fn) => fn(value), 1000);
//# sourceMappingURL=answer-comment.js.map